import { gql } from "@apollo/client/core";

export default gql`
    mutation DeleteCustomer($id: ID!) {
        deleteProject(input: { id: $id }) {
            errors
            status
            statusCode
        }
    }
`
